var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: this.manageType === "add" ? "新增产品Icon" : "修改产品Icon",
        visible: _vm.dialogVisible,
        width: "60%",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.listData,
            rules: _vm.rules,
            "label-position": "left",
            "label-width": "110px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "product_id", prop: "product_id" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "width-300",
                  attrs: {
                    filterable: "",
                    placeholder: "请选择产品product_id",
                  },
                  model: {
                    value: _vm.listData.product_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.listData, "product_id", $$v)
                    },
                    expression: "listData.product_id",
                  },
                },
                _vm._l(_vm.allProductList.slice(1), function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: "" + item.name + (item.id ? " " + item.id : ""),
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("ImageUpload", {
            ref: "iconUrlUpload",
            attrs: {
              groupFlag: false,
              ruleForm: _vm.iconUrl,
              labelTitle: "icon",
              labelWidth: "110px",
            },
            on: {
              "update:ruleForm": function ($event) {
                _vm.iconUrl = $event
              },
              "update:rule-form": function ($event) {
                _vm.iconUrl = $event
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onCancel } }, [_vm._v("取 消")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("ruleForm")
                },
              },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }